import type { Permission } from '../types/external/2work/api/response/getDoctypePermissions.ts'

const PERMISSIONS: Record<Uppercase<Permission>, Permission> = {
  AMEND: 'amend',
  CANCEL: 'cancel',
  CREATE: 'create',
  DELETE: 'delete',
  EMAIL: 'email',
  EXPORT: 'export',
  IMPORT: 'import',
  PRINT: 'print',
  READ: 'read',
  REPORT: 'report',
  SELECT: 'select',
  SHARE: 'share',
  SUBMIT: 'submit',
  WRITE: 'write',
} as const

const HAS_LIST_VIEW_ONE_PERMISSION_OF: Permission[] = [PERMISSIONS.READ]
const HAS_DETAIL_VIEW_ONE_PERMISSION_OF: Permission[] = [PERMISSIONS.READ]
const HAS_CREATE_VIEW_ONE_PERMISSION_OF: Permission[] = [PERMISSIONS.CREATE]

export {
  HAS_CREATE_VIEW_ONE_PERMISSION_OF,
  HAS_DETAIL_VIEW_ONE_PERMISSION_OF,
  HAS_LIST_VIEW_ONE_PERMISSION_OF,
  PERMISSIONS,
}
